import React, { useEffect, useState } from 'react'
import { Form, Formik } from 'formik'
import { Check } from 'lucide-react'
import { toast } from 'react-toastify'
import { useParams } from 'react-router-dom'
import Card from '../../../../../components/Card'
import { socket } from '../../../../../util/socket'
import { Button, File } from '../../../../../components/Form'
import { api, authHeaders } from '../../../../../services/api'
import Table from '../../../../../components/Table'
import ProgressBar from '../../../../../components/ProgressBar'
import classNames from 'classnames'
import { twMerge } from 'tailwind-merge'
import { useQuery } from '@tanstack/react-query'

let interval

export default function () {
	const { id } = useParams()

	const [dadosPlanilha, setDadosPlanilha] = useState(null)
	const [podeConfirmarCarga, setPodeConfirmarCarga] = useState(false)
	const [usuariosProcessados, setUsuariosProcessados] = useState(0)
	const [usuariosCriados, setUsuariosCriados] = useState(0)
	const [usuariosNaoCriados, setUsuariosNaoCriados] = useState(0)

	async function handleCarregar(values) {
		try {
			const dados = await api.post(`parceiro/${id}/carga_usuarios`, values, authHeaders())

			setDadosPlanilha(dados.map(item => ({
				plano: `${item.validationError.includes('plano') ? 'X ' : ''} ${item.plano || ''}`,
				nome: `${item.validationError.includes('nome') ? 'X ' : ''} ${item.nome || ''}`,
				cpf: `${item.validationError.includes('cpf') ? '✖ ' : ''} ${item.cpf || ''}`,
				whatsapp: `${item.validationError.includes('whatsapp') ? '✖ ' : ''} ${item.whatsapp || ''}`,
				email: `${item.validationError.includes('email') ? '✖ ' : ''} ${item.email || ''}`,
				background: item.validationError.length > 0 ? '#ffcdd2' : undefined
			})))

			setPodeConfirmarCarga(dados.every(item => item.validationError.length === 0))

			toast.success('A planilha foi enviada.')

			activateSocketCommunication()
		} catch (e) {
			toast.error('Erro ao enviar a planilha.')
		}
	}

	async function handleConfirmarCarga() {
		try {
			await api.post(`parceiro/${id}/carga_usuarios/confirmacao`, { data: dadosPlanilha }, authHeaders())

			toast.success('Os usuários estão sendo criados.')

			// startSimulation()
		} catch (e) {
			toast.error(e.msg || 'Erro ao carregar os dados da planilha.')
		}
	}

	// function startSimulation() {
	// 	interval = setInterval(() => {
	// 		cont++

	// 		setUsuariosProcessados(old => old + 1)

	// 		setUsuariosCriados(old => cont % 2 !== 0 ? old + 1 : old)
	// 		setUsuariosNaoCriados(old => cont % 2 === 0 ? old + 1 : old)
	// 	}, 800)
	// }

	const { data: parceiro } = useQuery({
		queryKey: ['get-parceiro-by-id'],
		queryFn: async () => {
			const response = await api.get(`parceiro/${id}`, authHeaders())

			const clientes = response.clientes.map(cliente => ({
				id: cliente.id,
				nome: cliente.nome,
				whatsapp: cliente.contato.find(c => c.tipo_contato_id === 4)?.contato || '',
				email: cliente.contato.find(c => c.tipo_contato_id === 6)?.contato || '',
				cpf: cliente.documentos.find(c => c.tipo_documento_id === 2)?.identificador || ''
			}))

			return {
				...response,
				clientes
			}
		}
	})

	useEffect(() => {
		if(usuariosProcessados === 4) {
			clearInterval(interval)
		}
	}, [usuariosProcessados])

	function activateSocketCommunication() {
		console.log('Listeners acionados...')

		socket.addListener('usuario-criado', () => {
			setUsuariosProcessados(old => old + 1)
			setUsuariosCriados(old => old + 1)
		})

		socket.addListener('usuario-nao-criado', () => {
			setUsuariosProcessados(old => old + 1)
			setUsuariosNaoCriados(old => old + 1)
		})
	}

	useEffect(() => {
		if(dadosPlanilha && usuariosProcessados === dadosPlanilha.length) {
			return () => {
				console.log('socket desligado...')

				socket.detachEvents()

				// history.push(`/admin/parceiros/`)
			}
		}
	}, [usuariosCriados, dadosPlanilha])

	const progress = dadosPlanilha ? (usuariosProcessados * 100) / dadosPlanilha.length : 0
	const isFinished = progress === 100

	return (
		<div className="flex flex-col text-slate-800 sm:mx-4 sm:my-6 md:my-12 leading-loose">
			<Card className="flex flex-col">
				<h1 className="text-slate-800 mb-4">Carga de usuários</h1>

				{!dadosPlanilha ? (
					<Formik
						onSubmit={handleCarregar}
						initialValues={{
							planilha: null
						}}
					>
						{({ errors, setFieldValue }) => (
							<Form className="flex flex-col items-end">
								<File
									name="planilha"
									label="Anexe aqui a planilha de usuários"
									onSuccess={fileId => setFieldValue('planilha', fileId)}
									format="square"
									error={errors.planilha}
									style={{ width: 'calc(100% - 16px)' }}
									previewSize={['100%', '140px']}
								/>

								<Button type="submit">
									Enviar planilha
								</Button>
							</Form>
						)}
					</Formik>
				) : (
					<div className="flex flex-col items-end gap-4">
						<p className="self-start">Confirme os dados antes de concluir a carga.</p>

						<Table
							headers={[
								{ name: 'nome', value: 'Nome' },
								{ name: 'cpf', value: 'CPF', centered: true },
								{ name: 'whatsapp', value: 'Fone', centered: true },
								{ name: 'email', value: 'E-mail', centered: true },
								{ name: 'plano', value: 'Plano', centered: true }
							]}
							data={dadosPlanilha}
						/>

						<Button onClick={handleConfirmarCarga} disabled={!podeConfirmarCarga}>
							Confirmar carga
							<Check size={16} />
						</Button>

						<div className="w-full">
							<ProgressBar
								visible
								percentage={progress}
								hint="Percentual de usuários processados"
							/>
						</div>

						<div className={twMerge(classNames('hidden flex-col gap-2 text-red-500', { 'flex': isFinished }))}>
							<span>Processados: {usuariosProcessados}</span>
							<span>Criados: {usuariosCriados}</span>
							<span>Não criados: {usuariosNaoCriados}</span>
							<span>TOTAL: {dadosPlanilha.length}</span>
						</div>
					</div>
				)}
			</Card>

			<Card className="flex flex-col">
				<h1 className="text-slate-800 mb-4">Beneficiários</h1>

				{parceiro?.clientes && parceiro.clientes.length > 0 ? (
					<Table 
						headers={[
							{ name: 'nome', value: 'Nome' },
							{ name: 'cpf', value: 'CPF' },
							{ name: 'whatsapp', value: 'Fone' },
							{ name: 'email', value: 'E-mail' }
						]}
						data={parceiro.clientes}
					/>
				) : (
					<div className="flex flex-col gap-4">
						<span className="font-bold text-lg">Nenhum beneficiário cadastrado</span>
					</div>
				)}
			</Card>
		</div>
	)
}
